
import * as React from "react";
import { db } from '../../../firebase-info';
import {
	doc,
	updateDoc,
} from "firebase/firestore";
import { AuthContext, ThemeModeContext } from "../contexts/contexts.js";

const ThemeModeContextComponent = ({ children }) => {
  const [mode, setMode] = React.useState('light');

  const authContextValue = React.useContext(AuthContext);

  const loadThemeModePreferences = () => {
	setMode(authContextValue?.userData?.mode || 'light');
  };

  const saveMode = async () => {
	const userUID = authContextValue.userRef?.id;
	if (userUID) {
		await updateDoc(doc(db, "users", userUID), {
			mode
		});
	}
  }

  const themeModeContextValue = React.useMemo(() =>
	( { mode, setMode, } ),
	[ mode, setMode, ]
  );

  React.useEffect(() => {
	if(!authContextValue.loading){
		loadThemeModePreferences();
	}
  }, [authContextValue.loading, authContextValue?.userData]);

  React.useEffect(() => {
	saveMode();
  }, [mode]);

  return (
	<ThemeModeContext.Provider value={themeModeContextValue}>
		{children}
	</ThemeModeContext.Provider>
  )
}

export default ThemeModeContextComponent;